import apiClient from '../lib/apiClient';

export async function registerCustomer(payload) {
  const formData = new FormData();

  formData.append('name', payload.name.trim());
  formData.append('email', payload.email.trim());
  formData.append('mobile', payload.mobile.trim());
  formData.append('password', payload.password);

  const response = await apiClient.post('/auth/register', formData);

  return response.data;
}
